import $ from 'jquery';
import run from '../../utilities/run';
import { setElementsFromScope} from "../../utilities/selectorHelpers";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";

run(".walmart-connection-details", (mainEl)=>{
  const editPartnerUrl = mainEl.data("wmt-edit-channel-connection-url");
  const inactivateChannelUrl = mainEl.data("wmt-inactivate-channel-url");
  const activateChannelUrl = mainEl.data("wmt-activate-channel-url");
  const viewChannelDetailUrl = mainEl.data("wmt-view-channel-detail-url");
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  const els = {};
  const elementsMap = {
    inactivateBtn: ".inactivate-walmart-connection",
    activateBtn: ".activate-walmart-connection",
    pencilIcon: ".fa-pencil",
    editBtn: ".wmt-edit-partner-url"
  };
  // elements at document scope
  const docElementsMap = {
    inactivateModal: "#wmtInactivateModal",
    activateModal: "#wmtActivateModal",
    inactivateModalBtn: "#wmtInactivateChannel",
    activateModalBtn: "#wmtActivateChannel"
  };

  onLoad();

  function onLoad(){
    setElements();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, mainEl);
    setElementsFromScope(els, docElementsMap, $(document));
  }

  els.editBtn.on('click', function () {
    editWmtConnection();
  });

  els.pencilIcon.on('click', function () {
    editWmtConnection();
  });

  els.inactivateBtn.on( "click", function() {
    els.inactivateModal.modal("show");
  });
  
  els.activateBtn.on( "click", function() {
    els.activateModal.modal("show");
  });

  function editWmtConnection() {
    location.href = `${editPartnerUrl}`;
  }

  els.inactivateModalBtn.on('click', function () {
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: inactivateChannelUrl,
      success: onSuccess,
      error: onError
    });
  });

  els.activateModalBtn.on('click', function () {
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: activateChannelUrl,
      success: onSuccess,
      error: onError
    });
  });

  function onSuccess(data) {
    if(data.match("success")){
      submitModalFlow.showSuccessModal();
      setTimeout(function() {
      location.href=viewChannelDetailUrl;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }else{
      submitModalFlow.showFailureModal();
    }
  }

  function onError(data) {
    submitModalFlow.showFailureModal();
  }

});


// WEBPACK FOOTER //
// ./src/pages/createChannel/walmartConnectionDetails.js